module.exports = __webpack_public_path__ + "static/media/2.f5387270.jpg";